import { types, applySnapshot } from "mobx-state-tree";
import { Framework } from "@flint/framework";

const FooterModel = types
  .model("FooterModel", {
    footerBooks: types.array(
      types.model("EPub", {
        isbn: types.string,
        title: types.string,
        author: types.string,
        publisher: types.string,
      })
    ),
  })
  .actions((self) => ({
    fetch() {
      Framework.sendEvent("FETCHING_FOOTER_BOOKS");
    },
    set(response) {
      const footerBooks = response.data.response;
      applySnapshot(self, {
        footerBooks,
      });
    },
  }));

export default FooterModel;